module.exports = __webpack_public_path__ + "static/img/accommodation-main-img.10c5a954.svg";